<template>
    <div
        class="tip-container"
        :class="`tip-container__${tipData.type}`"
        :style="containerStyle"
    >
        <span
            class="arrow-container"
            :style="arrowPos"
        >
            <span class="arrow" />
        </span>
        <div class="tip-content">
            {{ tipData.message }}
        </div>
    </div>
</template>

<script>
/* eslint-disable vue/require-prop-types */
import $ from 'jquery';

export default {
    props: {
        tipData: {
            default: () => ({}),
        },
    },
    data() {
        return {
            containerStyle: {},
            arrowPos: null,
            width: 'auto',
        };
    },
    watch: {
        tipData() {
            this.getStyle();
        },
    },
    mounted() {
        this.getStyle();
        const pWidth = $(this.$el).parent().outerWidth();
        const width = $(this.$el).outerWidth() > pWidth * 0.9 ? pWidth * 0.9 : $(this.$el).outerWidth();
        if (width) {
            this.width = `${width}px`;
        }
    },
    methods: {
        getStyle() {
            const scrollTop = $(window).scrollTop();
            if (this.$el) {
                const pWidth = $(this.$el).parent().outerWidth();
                const offset = $(this.$el).parent().offset();
                const width = $(this.$el).outerWidth() > pWidth * 0.9 ? pWidth * 0.9 : $(this.$el).outerWidth();
                const { pageX } = this.tipData.target;
                const { pageY } = this.tipData.target;
                let left = pageX - offset.left;
                const top = pageY - offset.top;
                const overWidth = (left + width) - (pWidth);
                let arrowLeft = 10;
                if (overWidth > 0) {
                    left -= overWidth;
                    arrowLeft = overWidth + 10;
                }
                this.containerStyle = {
                    left: `${left + 10}px`,
                    top: `${top - scrollTop + 20}px`,
                    'max-width': `${pWidth * 0.9}px`,
                    'min-width': this.width,
                };
                this.arrowPos = {
                    left: `${arrowLeft}px`,
                };
            }
        },
    },
};
</script>
